module.exports = __webpack_public_path__ + "img/man-body-back.9fdb71b6.png";